// This is a utility component about manipulating cookieParser
// refer to documentation
// @author lamrpalex

// A function to read the value of one cookie
// if it does not exist returns empty string
function getCookieValue(name) {
  const value = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
  return value ? value.pop() : '';
}

// A function to clear all cookies on logout based on
// https://stackoverflow.com/questions/179355/clearing-all-cookies-with-javascript
function deleteAllCookies() {
  document.cookie.split(';').forEach((cookie) => {
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  });
}

module.exports = {
  getCookieValue,
  deleteAllCookies
};
